<app-sidenav>
  <div class="row p-4">
    <div class="col-12">
      <div class="d-flex align-items-center">

        <h2 class="page-title mb-0">
          Garantia Especial (DPGE) <br>
          Instituições em Regime Especial
        </h2>

        <div class="border-left mx-4 align-self-stretch"></div>

        <div>
          <small class="perfil-atual d-block">Perfil atual</small>
          <div class="d-flex align-items-center">
            <h2 class="page-title mb-0 mr-3">{{ textoTipoUserCognito }}</h2>
            <button type="button" class="btn btn-blue" (click)="trocarTipoCognito()">
              Mudar Perfil
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <ol class="row list-unstyled gy-3">
    <li
      *ngFor="let cardData of cardInstituicoes"
      class="col-lg-4 col-sm-12 col-md-6 my-2">
      <div class="card p-5 mh-100 d-flex justify-content center align-items-center">
        <div class="row card-corpo ">
          <div class="col-md-12 ">
            <h2 class="card-title ">{{ cardData.nome }}</h2>
            <h5 class="dataLiquidacao mt-2">
              Liquidação: {{ cardData.liquidacao | date: "dd/MM/yyyy" }}</h5>
            <h5 *ngIf="cardData.nomeEmpresaCredor" class="nomeEmpresa mt-2">{{ cardData.nomeEmpresaCredor }}</h5>
            <div class="row">
              <div class="col-md-12 d-flex justify-content-center">
                <button data-testid="botao-card-dpge" class="btn btn-green"
                        (click)="solicitarConsultaGarantia(cardData)">
                  Incluir ou Consultar DPGE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ol>
</app-sidenav>
